import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import HelpIcon from '../../assets/logos/HelpIcon.svg';
import '../../styles/PageHeader.css';
import NavigtionBack from "../../assets/logos/back-nav.svg"

const PageHeader = ({ title, subtitle, backPath }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(backPath || '/apps');
  };
  return (
    
    <div className="breadcrumb-wrapper">
      <div className="breadcrumb-left">
        <img src={NavigtionBack} alt="back button" onClick={goBack} className="clickable" />
        <span
          className="breadcrumb-item clickable default-crumb"
          onClick={goBack}
        >
          {subtitle}
        </span>

        <span className="breadcrumb-separator">/</span>

        <span
          className="breadcrumb-item-heading clickable active-crumb"
        >
          {title}
        </span>
      </div>

      <div className="breadcrumb-right">
        <img src={HelpIcon} alt="Help" className="help-icon" />
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  backPath: PropTypes.string,
};

export default PageHeader;
